// @mui material components
import Icon from "@mui/material/Icon";

// @mui icons
import GitHubIcon from "@mui/icons-material/GitHub";

// Pages
import AboutUs from "layouts/pages/landing-pages/about-us";
import ContactUs from "layouts/pages/landing-pages/contact-us";
import Author from "layouts/pages/landing-pages/author";
import SignIn from "layouts/pages/authentication/sign-in";

// Sections
import PageHeaders from "layouts/sections/page-sections/page-headers";
import Features from "layouts/sections/page-sections/featuers";
import Navbars from "layouts/sections/navigation/navbars";
import NavTabs from "layouts/sections/navigation/nav-tabs";
import Pagination from "layouts/sections/navigation/pagination";
import Inputs from "layouts/sections/input-areas/inputs";
import Forms from "layouts/sections/input-areas/forms";
import Alerts from "layouts/sections/attention-catchers/alerts";
import Modals from "layouts/sections/attention-catchers/modals";
import TooltipsPopovers from "layouts/sections/attention-catchers/tooltips-popovers";
import Avatars from "layouts/sections/elements/avatars";
import Badges from "layouts/sections/elements/badges";
import BreadcrumbsEl from "layouts/sections/elements/breadcrumbs";
import Buttons from "layouts/sections/elements/buttons";
//import Dropdowns from "layouts/sections/elements/dropdowns";
//import ProgressBars from "layouts/sections/elements/progress-bars";
//import Toggles from "layouts/sections/elements/toggles";
//import Typography from "layouts/sections/elements/typography";

const routes = [
  {
    name: "pages",
    icon: <Icon>dashboard</Icon>,
    columns: 1,
    rowsPerColumn: 2,
    collapse: [
      {
        name: "landing pages",
        collapse: [
          {
            name: "about us",
            route: "/pages/landing-pages/about-us",
            component: <AboutUs />,
          },
          {
            name: "contact us",
            route: "/pages/landing-pages/contact-us",
            component: <ContactUs />,
          },
          {
            name: "author",
            route: "/pages/landing-pages/author",
            component: <Author />,
          },
        ],
      },
      {
        name: "account",
        collapse: [
          {
            name: "sign in",
            route: "/pages/authentication/sign-in",
            component: <SignIn />,
          },
        ],
      },
    ],
  },
  {
    name: "Services",
    icon: <Icon>build_circle</Icon>,
    collapse: [
      {
        name: "Web Developmet",
        description: "Innovative Web Solutions",
        dropdown: true,
        collapse: [
          {
            name: "Layouts",
            href: "https://www.smashingmagazine.com/category/layouts",
            component: <PageHeaders />,
          },
          {
            name: "Animations",
            href: "https://www.css-tricks.com/almanac/properties/a/animation/",
            component: <Features />,
          },
          {
            name: "Components",
            href: "https://reactjs.org/docs/components-and-props.html",
            component: <Features />,
          },
          {
            name: "Forms",
            href: "https://www.formassembly.com/solutions/use-case/build-forms/",
            component: <Features />,
          },
        ],
      },
      {
        name: "IOT Development",
        description: "Smart Device Integration",
        dropdown: true,
        collapse: [
          {
            name: "Sensors",
            href: "https://www.iotforall.com/search?ss360Query=sensors",
            component: <Navbars />,
          },
          {
            name: "Dashboards",
            href: "https://www.iotforall.com/search?ss360Query=dashboards",
            component: <NavTabs />,
          },
          {
            name: "Controllers",
            href: "https://www.digi.com/search?q=controllers",
            component: <Pagination />,
          },
          {
            name: "Connectivity",
            href: "https://www.postscapes.com/?s=Connectivity",
            component: <Pagination />,
          },
        ],
      },
      {
        name: "AI/ML Developmet",
        description: "Advanced AI Applications",
        dropdown: true,
        collapse: [
          {
            name: "Models",
            href: "https://medium.com/tag/ai-and-ml-models",
            component: <Inputs />,
          },
          {
            name: "Training",
            href: "https://www.tensorflow.org/tutorials",
            component: <Forms />,
          },
          {
            name: "Inference",
            href: "https://machinelearningmastery.com/?s=interfaces&post_type=post&submit=Search",
            component: <Forms />,
          },
          {
            name: "Datasets",
            href: "https://www.kaggle.com/datasets",
            component: <Forms />,
          },
        ],
      },
      {
        name: "Software Developmet",
        description: "Custom Software Services",
        dropdown: true,
        collapse: [
          {
            name: "APIs",
            href: "https://swagger.io/resources/articles/best-practices-in-api-design/",
            component: <Alerts />,
          },
          {
            name: "Databases",
            href: "https://www.mongodb.com/databases",
            component: <Modals />,
          },
          {
            name: "Architecture",
            href: "https://martinfowler.com/architecture/",
            component: <TooltipsPopovers />,
          },
          {
            name: "Testing",
            href: "https://www.softwaretestinghelp.com/software-testing-tutorials/",
            component: <TooltipsPopovers />,
          },
        ],
      },
      {
        name: "Mobile App Developmet",
        description: "Engaging Mobile Experiences",
        dropdown: true,
        collapse: [
          {
            name: "UI/UX",
            href: "https://www.nngroup.com/articles/mobile-ux/",
            component: <Avatars />,
          },
          {
            name: "Frameworks",
            href: "https://flutter.dev/docs",
            component: <Badges />,
          },
          {
            name: "Performance",
            href: "https://developer.android.com/topic/performance",
            component: <BreadcrumbsEl />,
          },
          {
            name: "Deployment",
            href: "https://appmaster.io/blog/how-to-deploy-a-mobile-app",
            component: <Buttons />,
          },
          {
            name: "Security",
            href: "https://owasp.org/www-project-mobile-top-10/",
            component: <Buttons />,
          },
          {
            name: "Cross-Platform",
            href: "https://developer.mozilla.org/en-US/docs/Web/Progressive_web_apps/Offline_Service_workers",
            component: <Buttons />,
          },
        ],
      },
    ],
  },
  {
    name: "play list",
    icon: <Icon>playlist_play</Icon>,
    collapse: [
      {
        name: "Javascript",
        description: "The most popular programming language in the world.",
        href: "https://www.simplilearn.com/reasons-to-learn-javascript-article",
      },
      {
        name: "Python",
        description: "Becoming continuously more popular.",
        href: "https://www.simplilearn.com/learn-the-basics-of-python-article",
      },
      {
        name: "Java",
        description: "One of the world’s most popular; high demand.",
        href: "https://www.simplilearn.com/tutorials/java-tutorial/what-is-java",
      },
      {
        name: "C#",
        description: "Relatively popular, but not as popular as Java (its closest rival).",
        href: "https://www.javatpoint.com/c-sharp-tutorial",
      },
      {
        name: "PHP",
        description:
          "Used by nearly 80% of all active websites, so it is very popular with web developers.",
        href: "https://www.simplilearn.com/why-learn-php-article",
      },
    ],
  },
  {
    name: "github",
    icon: <GitHubIcon />,
    href: "https://www.github.com/SE-LAPS",
  },
];

export default routes;
